import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { mapState, mapActions } from "pinia";

import { ReferralService } from "../../../../../../services/referral-service";
import { IPageCallbackResult } from "../../../../../../resources-vue/vue-interfaces/i-page-container";
import { PAGE_FAIL_RESPONSE } from "../../../../../../resources-vue/vue-elements/Pagination/Pagination";
import { LocationService } from "../../../../../../services/location-service";
import { useConvertToPendingPal } from "../../../store/useConvertToPendingPal";
import { ServiceLocation } from "../../../../../../resources-vue/vue-models/location-service";
import { ToastrService } from "./../../../../../../services/toastr.service";

import FormSection from "../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";
import Pagination from "../../../../../../resources-vue/vue-elements/Pagination/Pagination.vue";
import AddServiceLocationForm from "./AddServiceLocationForm/AddServiceLocationForm.vue";
import ErrorMessageHandler from "../../../../../../resources-vue/vue-custom-elements/ErrorMessageHandler/ErrorMessageHandler.vue";
import ServiceLocationRow from "./ServiceLocationRow/ServiceLocationRow.vue";

export default defineComponent({
    components: {
        FormSection,
        Pagination,
        AddServiceLocationForm,
        ErrorMessageHandler,
        ServiceLocationRow
    },
    data(vm) {
        return {
            _referralService: null,
            _serviceLocationService: null,
            _toastrService: null,
            showServiceForm: false,
            page: null,
            isLoading: false,
            isError: false,
            columns: 4,
            serviceList: null,
            itemCount: null,
            service: new ServiceLocation()
        };
    },

    computed: {
        ...mapState(useConvertToPendingPal, ["patientDetails", "accountId", "application", "patientId"]),
        loadingCount() {
            return this.page?.items?.length > 0 ? this.page.items.length() : 5;
        },
        hasData() {
            return this.page?.itemCount > 0;
        }
    },

    created() {
        this._referralService = Container.instance.get(ReferralService);
        this._serviceLocationService = Container.instance.get(LocationService);
        this._toastrService = Container.instance.get(ToastrService);
    },

    mounted() {
        this.serviceList = this.$refs.serviceLocationList;
        this.resetList();
    },

    methods: {
        ...mapActions(useConvertToPendingPal, {
            resetErrors: "RESET_ERRORS"
        }),
        async pageChangedCallback(pageNumber: number, pageSize: number): Promise<IPageCallbackResult> {
            try {
                this.isError = false;
                let data = await this._serviceLocationService.getServiceLocations(this.patientId, {
                    page: pageNumber,
                    pageLength: pageSize,
                    application: this.application,
                    accountId: this.accountId
                });
                this.page = data;
                this.itemCount = data.itemCount;
                if (this.itemCount > 0) {
                    this.resetErrors("serviceLocation");
                }
                return {
                    totalPageCount: data.pageCount,
                    success: data.itemCount > 0,
                    totalCount: data.itemCount
                };
            } catch (e) {
                console.error(e);
                this.isError = true;
                return PAGE_FAIL_RESPONSE;
            }
        },
        resetList() {
            this.serviceList.reset();
        },
        openServiceLocationForm() {
            this.showServiceForm = true;
        },
        closeServiceForm() {
            this.showServiceForm = false;
        }
    }
});
